import React from 'react';

const CustomToast = ({ title, description }) => (
  <div>
    <strong style={{fontSize:'12px'}}>{title}</strong>
    <div style={{fontSize:'12px'}}>{description}</div>
  </div>
);

export default CustomToast;